<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('information.notice.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
          <span class="front_loc">{{ $t('information.title') }} > </span>
          <span class="middle_loc">{{ $t('information.notice.title') }} > </span>
          <span class="back_loc">{{ $t('common.common.list') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2 my_app_tabs_data">
          <div class="top__component__fold__wrap" v-if="component_fold">
            <v-row class="top_search_content2">
              <v-col cols="12" md="3">
                <label class="nec_title">{{ $t('information.notice.fields.date') }}</label>
                <div class="input_text_type_basic">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        hide-details
                        outlined
                        solo
                        dense
                        flat
                        v-model="dateFormatted"
                        hint="DD-MM-YYYY ~ DD-MM-YYYY format"
                        v-bind="attrs"
                        v-on="on"
                        append-icon="mdi-calendar"
                        class="date_type"
                        readonly
                        @click:append="menu = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" range no-title>
                      <v-spacer></v-spacer>
                      <!-- 여기서부터!!! -->
                      <v-btn text color="primary" @click="fnCancelSerchDate()">{{ $t('common.button.cancel') }}</v-btn>
                      <v-btn text color="primary" @click="fnSetSerchDate()" :disabled="date.length != 2">{{ $t('common.button.ok') }}</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
              <v-col cols="12" md="2">
                <div class="input_text_type_basic" style="min-width:100%;">
                  <v-select
                    dense
                    outlined
                    hide-details
                    v-model="searchOption.searchType"
                    :items="$vuetify.rtl ? noticeTypeCodeListAr : noticeTypeCodeListEn"
                  >
                  </v-select>
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="input_text_type_basic">
                  <v-text-field
                    placeholder=""
                    dense
                    outlined
                    hide-details
                    clearable
                    v-model="searchOption.searchKeyword"
                  >
                  </v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="3" class="mobile__dcolumn">
                <v-btn class="t_search_btn wp50" color="#a01c2a" dark height="40" @click="fnGetNoticeList()">
                  <v-icon>mdi-magnify</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.search') }}
                </v-btn>
                <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                <v-btn class="t_search_btn wp50" color="#222" dense dark height="40" @click="fnReset()">
                  <v-icon>mdi-restart</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.reset') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <!-- 상단 레이아웃 접는 기능영역 : S -->
          <div class="fold__actions__wrap">
            <v-btn @click="foldingActions()" :class="{actv : component_fold}" color="#dedede" small min-width="120px"><v-icon x-small color="#727272">mdi-triangle</v-icon></v-btn>
          </div>
          <!-- 상단 레이아웃 접는 기능영역 : E -->


          <v-data-table
            :headers="$getHeaderType1(headerTxt, headers)"
            :items="noticeList"
            hide-default-footer
            class="elevation-0 myapp_table_type2 type4 mt-30"
            :page.sync="paging.page"
            :items-per-page="paging.pageSize"
            @page-count="paging.pageCount = $event"
            :mobile-breakpoint="MobileBreakPoint"
          >
          <template v-slot:item="{ item }">
              <tr :class="{'notice' : item.ind_top == 'Y'}">
                <td>
                  <v-chip class="short" v-ripple :color="getColor(item.notice_type_code)" dark>{{ $vuetify.rtl ? item.code_name_ar : item.code_name_en }}</v-chip>
                </td>
                <td v-if="$vuetify.rtl" class="text-right" style="cursor:pointer;" @click="fnGoNoticeView(item.seq)">
                  {{ item.subject_ar }}
                </td>
                <td v-if="!$vuetify.rtl" class="text-left" style="cursor:pointer;" @click="fnGoNoticeView(item.seq)">
                  {{ fnIsNull(item.subject_en) ? item.subject_ar : item.subject_en }}
                </td>
                <td>
                  <template v-if="getFileAttachShowYn($vuetify.rtl ? item.attached_ar_file_key : item.attached_en_file_key)">
                    <a class="attach__mt ty3" style="text-decoration:none" :href="downLoadUrl + ($vuetify.rtl ? item.attached_ar_file_key : item.attached_en_file_key)">
                      <!-- <v-icon>{{ getExtIcon($vuetify.rtl ? item.attached_ar_file_ext : item.attached_en_file_ext) }}</v-icon> -->
                      <v-icon color="#a01c2a">mdi-email</v-icon>
                      <v-icon color="#fff" class="inner_icon">mdi-paperclip</v-icon>
                    </a>
                  </template>
                </td>
                <td class="text-center" style="cursor:pointer;">{{ item.date }}</td>
                <td style="cursor:pointer;">{{ item.read_count }}</td>
              </tr>
          </template>
          </v-data-table>

          <div class="v-data-table board_basic_wrap theme--light mb-30">
            <div class="v-data-table-footer page_nation_wrap">
              <pagination :paging.sync="paging" />
            </div>
          </div>
        </v-flex>

      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import Pagination from '@/components/layout/Pagination'
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  name : 'Notice',
  components :{
    Pagination
  },
  data () {
    return {
      MobileBreakPoint : 0,
      component_fold : false,
      date: [],
      dateFormatted: '',
      menu: false,

      headerTxt : {
        prefix : 'information.notice.fields.',
        txt : [ '','title','attachment','date','views' ]
      },
      headers: [
        { text: '', align: 'center', value: '',sortable: false, width:'10%'},
        { text: this.$t('information.notice.fields.title'), align: 'center', value: '',sortable: false, width:350},
        { text: this.$t('information.notice.fields.attachment'), align: 'center', value: '', width: '180px' ,sortable: false, },
        { text: this.$t('information.notice.fields.date'), align: 'center', value: '',sortable: false, width:120},
        { text: this.$t('information.notice.fields.views'),  align: 'center', value: '',sortable: false, width:120},

      ],

      // 페이징 처리
      paging: {
        page: 1,
        pageSize: 10,
        pageCount: 0,
        totalCount: 0
      },

      noticeTypeCodeListAr : [],
      noticeTypeCodeListEn: [],

      noticeList : [],

      searchOption : {
        searchInactiveInd : 'N', // linkage는 기본이 Y, Inactive 값도 봐야하기 때문에
        searchType : '',
        searchKeyword : '',
        searchStartDate : null, // this.formatDate(new Date().toISOString().substr(0, 10)),
        searchEndDate : null,    //this.formatDate(new Date().toISOString().substr(0, 10)),
        searchIndTopOrder : 'Y'
      },

      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/'
    }
  },
  created() {
    if(!utils.isNull(this.$route.params.searchType)){
      this.searchOption.searchType = this.$route.params.searchType
    }

    if(!utils.isNull(this.$route.params.searchKeyword)){
      this.searchOption.searchKeyword = this.$route.params.searchKeyword
    }

    if(!utils.isNull(this.$route.params.searchStartDate) && !utils.isNull(this.$route.params.searchEndDate)){
      this.searchOption.searchStartDate = this.$route.params.searchStartDate
      this.searchOption.searchEndDate = this.$route.params.searchEndDate
      this.date = this.$route.params.date
      this.dateFormatted = this.$route.params.dateFormatted
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    // 폴딩 브라우저 사이즈 체크 하여 접고 여는 부분 체크
    this.onResize()
    //window.addEventListener('resize', this.onResize, { passive: true })

    //넘겨받은 쿼리스트링을 검색 파라메터에 삽입
    let param = utils.qryStrToJson(location.href)
    if(param){
      this.searchOption = param
      if(!utils.isNull(param.searchStartDate)){
        this.date[0] = this.formatDate2(param.searchStartDate)
        this.date[1] = this.formatDate2(param.searchEndDate)
        this.dateFormatted = this.formatDate(this.date[0]) + ' ~ ' + this.formatDate(this.date[1])
      }
    }
    this.fnInit()
  },
  beforeDestroy (){
    // 리사이징 이벤트 제거
    if (typeof window === 'undefined') {
      return
    }
    window.removeEventListener('resize', this.onResize, { passive: true });
  },
  methods: {
    onResize () {
      this.component_fold = window.innerWidth < 960 ? false : true
    },
    foldingActions(){
      this.component_fold = !this.component_fold
    },
    fnInit() {
      // Status
      let options = {
        upper_code: '6900',
        all: true,
        remove: [
          {code: '6905'}
        ]

      }
      utils.fnGetCodeList(options).then(list => {
        this.noticeTypeCodeListAr = list.ar
        this.noticeTypeCodeListEn = list.en
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      this.fnGetNoticeList()
    },
    fnReset(){


      this.searchOption.searchInactiveInd = 'N' // linkage는 기본이 Y, Inactive 값도 봐야하기 때문에
      this.searchOption.searchType = ''
      this.searchOption.searchKeyword = ''
      this.searchOption.searchStartDate = null // this.formatDate(new Date().toISOString().substr(0, 10)),
      this.searchOption.searchEndDate = null    //this.formatDate(new Date().toISOString().substr(0, 10)),
      this.searchOption.searchIndTopOrder = 'Y'
      this.date = []
      this.dateFormatted = ''

    },
    fnGetNoticeList(){
      requestApi({
        url: '/info/notices',
        method: 'GET',
        data: this.searchOption,
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].date = utils.replaceAll(res.data.list[i].write_date, '-', '/')
            }
            this.noticeList = res.data.list
            this.paging.totalCount = res.data.list.length

            if(!utils.isNull(this.$route.params.page)){
              this.paging.page = this.$route.params.page
            }
            if(!utils.isNull(this.$route.params.pageSize)){
              this.paging.pageSize = this.$route.params.pageSize
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetNoticeList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnCancelSerchDate(){
      this.menu = false
      if(!utils.isNull(this.dateFormatted)){
        let dataRange = this.dateFormatted.split(' ~ ')
        this.date = []
        this.date.push(this.parseDate(dataRange[0]))
        this.date.push(this.parseDate(dataRange[1]))
      }else{
        this.date = []
      }
    },
    fnSetSerchDate(){
      this.dateFormatted = this.formatDate(this.date[0]) + ' ~ ' + this.formatDate(this.date[1])
      this.searchOption.searchStartDate = this.formatDate(this.date[0])
      this.searchOption.searchEndDate = this.formatDate(this.date[1])
      this.menu = false
    },
    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    formatDate2 (date) {
      if (!date) return ''
      const [day, month, year] = date.split('-')
      return `${year}-${month}-${day}`
    },
    parseDate (date) {
      if (!date) return ''
      const [day, month, year] = date.split('-')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getFileAttachShowYn(fileKey){
      return !utils.isNull(fileKey)
    },
    fnGoNoticeView(seq){
      let qryStr = utils.jsonToQryStr(this.searchOption)
      this.$router.push({path : '/information/notice/' + seq + qryStr})
    },
    fnIsNull(val){
      return utils.isNull(val)
    },
    getExtIcon(fileExt){
      let ext = fileExt.toLowerCase()
      if(ext == 'doc' || ext == 'docx'){
        return 'mdi-file-word'
      }else if(ext == 'xlsx' || ext == 'xls'){
        return 'mdi-file-excel'
      }else if(ext == 'ppt' || ext == 'pptx'){
        return 'mdi-file-ppt'
      }else if(ext == 'pdf'){
        return 'mdi-file-pdf'
      }else if(ext == 'png' || ext == 'bmp' || ext == 'rle' || ext == 'dib' ||ext == 'gif' || ext == 'tif' || ext == 'tiff' || ext == 'jpg' ){
        return 'mdi-file-image'
      //}else if(ext == 'txt'){
      //  return 'text-box-outline'
      }else{
        return 'mdi-paperclip'
      }
    },
    getColor (code) {
      if (code === '6901') return '#b22325'
      else if (code === '6902') return '#f59a41'
      else if (code === '6903') return '#1f94a6'
      else if (code === '6905') return '#c1c1c1'
    },
    //attach:'mdi-file-word',
      //attach:'mdi-file-pdf',
  },
}
</script>
<style>
.short{
  width:70px;
}
</style>